import { render, staticRenderFns } from "./PorqueViajar.vue?vue&type=template&id=0682bddf&scoped=true"
import script from "./PorqueViajar.vue?vue&type=script&lang=js"
export * from "./PorqueViajar.vue?vue&type=script&lang=js"
import style0 from "./PorqueViajar.vue?vue&type=style&index=0&id=0682bddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0682bddf",
  null
  
)

export default component.exports